// src/api/itemVariantPackageService.js ver 01 Jan 16 2026 4:00am SB120b
// src/api/itemVariantPackageService.js ver 00 Jan 11 2026 11:13pm SB119
import { callCloudFunction } from './apiClient';

export const getItemVariantPackages = async (tenantid, token, page = 1, limit = 20, statusFilter = 'Active') => {
  return callCloudFunction('itemVariantPackageCrud', 'GET', null, null, token, null,{
      pathParams: { tenantid, operation: 'list' },
      queryParams: { page, limit, statusfilter: statusFilter }
  });
};

export const getItemVariantPackageById = async (tenantid, id, token) => {
  return callCloudFunction('itemVariantPackageCrud', 'GET', null, id, token, null,{
      pathParams: { tenantid, operation: 'getById', id }
  });
};

export const addItemVariantPackage = async (tenantid, itemVariantPackageData, token) => {
  return callCloudFunction('itemVariantPackageCrud', 'POST', itemVariantPackageData, null, token, null,{
      pathParams: { tenantid, operation: 'add' }
  });
};

export const updateItemVariantPackage = async (tenantid, id, itemVariantPackageData, token) => {
  return callCloudFunction('itemVariantPackageCrud', 'PUT', itemVariantPackageData, null, token, null,{
      pathParams: { tenantid, operation: 'update', id }
  });
};

// NEW: Helper to fetch active ItemVariantPackage names for dropdowns
export const listActiveItemVariantPackageNames = async (tenantid, token) => {
    // Calls itemVariantPackageCrud 'listActvItmVrntPkgNm' operation directly
    return callCloudFunction('itemVariantPackageCrud', 'GET', null, null, token, null,{
        pathParams: { tenantid, operation: 'listActvItmVrntPkgNm' } // operation is part of pathParams
    });
};